// src/components/ui/fullscreen-spinner.tsx
export default function FullscreenSpinner() {
  return (
    <div className="flex items-center justify-center h-screen w-full bg-background">
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-primary" />
    </div>
  )
}
